import { render, staticRenderFns } from "./PressCheck.vue?vue&type=template&id=c26de3e6&"
import script from "./PressCheck.vue?vue&type=script&lang=js&"
export * from "./PressCheck.vue?vue&type=script&lang=js&"
import style0 from "./PressCheck.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports